/*eslint-disable*/
import { FormikContext, useField } from 'formik';
import React, { useContext } from 'react';


export const useSafeField = (name: string | undefined) => {
  const formikContext = useContext(FormikContext);
  const isFormikEnabled = !!(formikContext && name);
  

  if (isFormikEnabled) {
    return useField(name!);
  }

  return [
    { value: '' },
    { name: '' },
    { error: '', touched: false },
    { setValue: () => {}, setTouched: () => {} }, 
  ];
};
